import { ScheduledQueryCadence } from '@api';

import type { PromptFormValue } from '../PromptForm';

export const buildCadence = (
  value: PromptFormValue,
  timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): ScheduledQueryCadence | undefined => {
  if (!value.scheduleEnabled) {
    return undefined;
  }

  const { frequency } = value;

  return {
    frequency,
    time_window: value.deliveryTime,
    timezone,
    ...(frequency === 'daily' && {
      skip_weekends: value.skipWeekends,
    }),
    ...(frequency !== 'daily' && {
      day_of_week: value.day,
    }),
    ...(frequency === 'monthly' && {
      occurrence: value.occurrence,
    }),
  };
};
